import React, { useEffect, useRef, useState } from 'react';
import smoothscroll from 'smoothscroll-polyfill';
import { getZoom, isMobileDevice, isMobileUI } from '../../constants';

import { isEs } from "../../libs/lang";


const MastheadHousing = ({isMobile, shouldBeInert}) => {
	const mastheadRef = useRef(null);
	const [mastheadHeight, setHeight] = useState(false);

	useEffect(() => {
		smoothscroll.polyfill();

		let zoom = getZoom();

		function isZooming() {
			const newZoom = getZoom();
			let returnVal = false;
			if (newZoom !== zoom) {
				zoom = newZoom;
				returnVal = true;
			}
			return returnVal;
		}


		const isIE11 = () => !(window.ActiveXObject) && "ActiveXObject" in window;

		function setStickyCta() {
			if (isIE11() && !isMobileDevice() && (isMobileUI(768) || zoom >= 2)) {
				document.body.style.position = '';
				const nav = document.getElementById('masthead');
				mastheadRef.current.style.marginTop = '0';
			}
		}

		if (!mastheadHeight && window.innerWidth < 768) {
			// only set the masthead height once, on page load.
			// otherwise, on mobile devices, the masthead would grow once the user scrolls and
			// the browser bar disappears
			setHeight(true);

		}

		// WCAG support - needed so that background video remains visible once mobile ui is shown on desktop
		window.addEventListener('resize', e => {
			if (isMobileUI(768) && !isMobileDevice()) {
				document.getElementById('masthead').style.height = '100vh';
			}
		})

		window.setTimeout(() => {
			setStickyCta();
		}, 50);

		window.addEventListener('resize', () => {
			if (isZooming()) {
				setStickyCta();
			}
		});
		window.addEventListener('scroll', () => {
			setStickyCta();
		});

	}, [mastheadHeight]);

	const bgImg = isEs() ? "Una niña sube las escaleras y sonríe." : "Child walking up the steps and smiling.";

	return (
		<div id="masthead" ref={mastheadRef}>
			<div className="bg-img" role="img" aria-label={bgImg} alt={bgImg}/>
			<div className="masthead-text">
				<div className="heading">
					{
						isEs()
							? <h1 id="housing-main-h1" className="es" tabIndex="-1">Abordamos el acceso a la vivienda a precio asequible desde todos los ángulos</h1>
							// : <h1 id="housing-main-h1" tabIndex="-1">Addressing<br/>housing<br/>affordability<br/>from every angle</h1>
						: <h1 id="housing-main-h1" tabIndex="-1">Addressing housing affordability from&nbsp;every&nbsp;angle</h1>

					}
				</div>
			</div>
		</div>
	)
}

export default MastheadHousing;
